import styled from 'styled-components';
import MyCashHeaderSvg from '../../assets/header/my_cash.svg';

const MyCashHeaderIcon = styled(MyCashHeaderSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
    width: ${props => props.width || '1.8rem'};
    height: ${props => props.height || '1.8rem'};
`;

export default MyCashHeaderIcon;
